// Strip the bits of a UK address that are implicit in a London-area
// booking - ", London" (the service area is London by definition) and the
// trailing ", UK" (always true). Used to keep the booking summary panels
// readable on narrow viewports without losing the actually useful parts
// (street + postcode). Mirrors the operator dashboard's simplifier.
export const simplifyAddress = address => {
  if (!address) return null
  return address
    .replace(/,\s*London\b\s*/i, ', ')
    .replace(/,\s*UK\s*$/i, '')
    .replace(/\s+/g, ' ')
    .replace(/,\s*,/g, ',')
    .trim()
    .replace(/,$/, '')
}

// Is the house number or name there? Anything that is not the postcode
// will do: "12", "Flat 3, 9" and "Elm Court" pass, an empty box or the
// postcode typed a second time does not. Car park, level and bay go in the
// notes. Mirrors Order#address_has_a_house (Robin, 5 Oct 2026: "think
// postcode and house number").
const POSTCODE_IN_TEXT = /\b[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}\b/gi
export const hasHouse = text => /[\p{L}\p{N}]/u.test(String(text || '').replace(POSTCODE_IN_TEXT, ' '))
